define('core/extensions/helpers/switch',[
    'core/switches',
    'core/utils/object/extend',
], function (
    switches,
    extend
) {
    'use strict';

    /*
     * @switch helper check if switch is active
     * Examples:
     *   - simply specify the switch you'd like to check
     *
     *     {{#if (switch "newHomepageReleased")}}something{{/if}}
     *
     */
    return function (value, options) {
        return switches.isFeatureActive(value, extend({}, options.hash));
    };
});

